import { apis } from '@doltech/core/lib/api/api.config';
import { apiUrls } from '@doltech/core/lib/api/api.urls';
import { components } from '@doltech/dto';
import { TestTypeEnum } from '@doltech/utils/lib/constants';

export const getTestDetail = async (testDetailId: string, trialUserId: string = null) => {
  const response = await apis.onlineTest.get<
    components['schemas']['UserFullTestDTO'] | components['schemas']['UserPracticeTestDTO']
  >(apiUrls.onlineTest.USER_TEST, {
    userTestId: testDetailId,
    trialUserId,
  });

  const { testType } = response.data;
  let testId = testDetailId;
  switch (testType) {
    case TestTypeEnum.PRACTICE_TEST: {
      testId = (response.data as components['schemas']['UserPracticeTestDTO']).testSection.id;
      break;
    }
    case TestTypeEnum.FULL_TEST: {
      testId = (response.data as components['schemas']['UserFullTestDTO']).test.id;
      break;
    }
    default:
  }

  const testInfoDetailRes = await apis.pageManagement.get<components['schemas']['TestDetailDTO']>(
    apiUrls.pageManagement.GET_TEST_INFORMATION_DETAIL,
    {
      testType,
      testId,
    }
  );

  return { ...testInfoDetailRes.data, ...response.data };
};

interface SubmitTestParams {
  testId: string;
  userAnswers: components['schemas']['UserSubmitTestDTO'];
  trialUserId?: string;
}

export const submitTest = async (variables: SubmitTestParams) => {
  const { testId: userTestId, userAnswers: payload, trialUserId } = variables;
  const response = await apis.onlineTest.post<components['schemas']['ResponseDTO']>(
    apiUrls.onlineTest.USER_TEST,
    payload,
    {
      params: { userTestId, trialUserId },
    }
  );
  return response.data;
};

export const updateUserTestProgress = async ({
  userTestId,
  payload,
  currentSectionIndex,
  trialUserId,
}: {
  userTestId: string;
  payload: components['schemas']['UserSubmitTestDTO'];
  currentSectionIndex?: number;
  trialUserId?: string;
}) => {
  const response = await apis.onlineTest.put<components['schemas']['ResponseDTO']>(
    apiUrls.onlineTest.USER_TEST,
    payload,
    {
      params: {
        userTestId,
        currentSectionIndex,
        trialUserId,
      },
    }
  );
  return response.data;
};

export const startOrResumePracticeTest = async ({ testSectionId, forceRestart, trialUserId }) => {
  const response = await apis.onlineTest.post<components['schemas']['UserTestDTO']>(
    apiUrls.onlineTest.USER_START_OR_RESUME_PRACTICE_TEST(testSectionId),
    {},
    {
      params: {
        forceRestart,
        trialUserId,
      },
    }
  );
  return response.data;
};

export const startOrResumeFullTest = async ({ testId, forceRestart, trialUserId }) => {
  const response = await apis.onlineTest.post<components['schemas']['UserTestDTO']>(
    apiUrls.onlineTest.USER_START_OR_RESUME_FULL_TEST(testId),
    {},
    {
      params: {
        forceRestart,
        trialUserId,
      },
    }
  );
  return response.data;
};
